import { Outlet } from 'react-router-dom'
import { getCookie } from '@/shared/lib/cookies'
import { isChinaFacingLexClient } from '@/shared/lib/isChinaFacingLexClient'
import { cn } from '@/shared/lib/utils'
import { useAutoCollapseSidebarInComplianceStudios } from '@/shared/hooks/useAutoCollapseSidebarInComplianceStudios'
import { LayoutProvider } from '@/context/layout-provider'
import { SearchProvider } from '@/context/search-provider'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { ChinaPsbFilingFooter } from '../china-psb-filing-footer'

function ComplianceStudioSidebarAutoCollapse() {
  useAutoCollapseSidebarInComplianceStudios()
  return null
}

type AuthenticatedLayoutProps = {
  children?: React.ReactNode
}

export function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  const defaultOpen = getCookie('sidebar_state') !== 'false'
  const showChinaPsbFiling = isChinaFacingLexClient()
  return (
    <SearchProvider>
      <LayoutProvider>
        <SidebarProvider
          defaultOpen={defaultOpen}
          className='h-svh overflow-hidden'
        >
          <ComplianceStudioSidebarAutoCollapse />
          <AppSidebar />
          <SidebarInset
            className={cn(
              'flex flex-col overflow-hidden',
              'h-svh',
              // Inset variant adds vertical m-2; shrink height so the shell fits in the viewport.
              'md:peer-data-[variant=inset]:h-[calc(100svh-(var(--spacing)*4))]',

              // Set content container, so we can use container queries
              '@container/content'
            )}
          >
            <div
              className={cn('flex min-h-0 flex-1 flex-col', 'overflow-y-auto')}
            >
              {children != null ? children : <Outlet />}
              {showChinaPsbFiling && (
                <ChinaPsbFilingFooter className='shrink-0 py-1 text-left' />
              )}
            </div>
          </SidebarInset>
        </SidebarProvider>
      </LayoutProvider>
    </SearchProvider>
  )
}
